import React, { useState, useRef, useEffect } from 'react';
import { FormikProps } from 'formik';
import { OrderingForSaleProps } from './detailsOrder.props';
import { CustomerPaymentState } from '../../types/types';
import { PaymentType } from '../../interfaces/enum/paymentType';
import CustomerForm from "../customerForm";
import Spinners from '../spinner/spinner';
import { ConfigServer } from '../../configs/config.server';
import { usePay } from '../../hooks/usePay';
import { Card, Col, Row } from 'react-bootstrap';
import { Position } from '../../interfaces/ordering/sale/position';
import _ from 'lodash';
import { usePayTinkoff } from '../../hooks/usePayTinkoff';
import { Device } from '../../infrastructure/Device';

const initialState: CustomerPaymentState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  paymentInstallments: 0,
  isLoading: false,
  paymentType: PaymentType.PayByCard
};

export const DetailsOrder = (props: OrderingForSaleProps): JSX.Element => {
  const [state, setState] = useState<CustomerPaymentState>(initialState);
  const formikRef = useRef<FormikProps<CustomerPaymentState>>(null);

  const config = ConfigServer(props.hostName);
  const { pay, isLoading: payLoading } = usePay(props, config);
  const { payTinkoff, isLoading: tinkoffLoading } = usePayTinkoff(props);

  const isLoading = state.isLoading || payLoading || tinkoffLoading;

  useEffect(() => {
    if (props.orderingForSale?.customer) {
      const { firstName, lastName, email, phone } = props.orderingForSale.customer;
      const phoneResult = props.isVisiblePhone ? (phone === 0 ? '' : phone.toString()) : phone === 0 || phone === null ? '79161111111' : phone.toString();

      setState((prev) => ({
        ...prev,
        firstName,
        lastName,
        email,
        phone: phoneResult
      }));
    }
  }, [props.orderingForSale]);

  const handleSubmit = (values: CustomerPaymentState) => {
    switch (state.paymentType) {
      case PaymentType.PayByCard:
        pay(values);
        break;
      case PaymentType.Tinkoff:
        if (props.accountPaymentForTinkoff) {
          payTinkoff(values, props.accountPaymentForTinkoff);
        }

        break;
    }
    return;
  };

  const renderOrderInfo = () => {
    const { orderingForSale } = props;
    if (!orderingForSale) return null;

    const orderNumberText = orderingForSale.orderNumber
      ? `Ваш заказ № ${orderingForSale.orderNumber}:`
      : 'Ваш заказ:';

    return (
      <>
        <Device desktop>
          <Row>
            <Col md={12} lg={12} xl={12} xxl={12} className="order-info-block">
              <p className="bb" data-qa-locator="text-order-number">
                {orderNumberText}
              </p>

              <div data-qa-locator="text-position-name-list">
                {orderingForSale.positionList.map((position: Position, index: number) => (
                  <p key={index}>{position.productName}</p>
                ))}
              </div>

              {orderingForSale.recurrentInfo && (
                <p className="order-info-block-description">
                  Сумма оплаты по заказу:{" "}
                  {orderingForSale.recurrentInfo.amountFirstPayment.toLocaleString("ru")}
                  &nbsp;
                  <i className="fa-solid fa-ruble-sign" style={{ fontSize: "0.85em" }} />
                </p>
              )}
              {orderingForSale.prePaymentAmount &&
                orderingForSale.prePaymentAmount > 0 && (
                  <p className="order-info-block-description">
                    Сумма по заказу:{" "}
                    {orderingForSale.totalSum.toLocaleString("ru")}&nbsp;
                    <i className="fa-solid fa-ruble-sign" style={{ fontSize: "0.85em" }} />
                  </p>
                )}
            </Col>
          </Row>
        </Device>

        <Device mobile>
          <Row>
            <Col xs={12} className="order-info-block">
              <p className="bb" style={{ marginBottom: 0 }} data-qa-locator="text-order-number">
                {orderNumberText}
              </p>
              <div data-qa-locator="text-position-name-list">
                {orderingForSale.positionList.map((position: Position, index: number) => (
                  <p className="lh-sm" key={index} style={{ marginBottom: 0 }}>
                    {position.productName}
                  </p>
                ))}
              </div>
            </Col>
          </Row>
        </Device>
      </>
    );
  };

  const renderCustomerForm = () => {
    const { orderingForSale } = props;
    if (!orderingForSale) return null;

    const commonFormProps = {
      initialValues: {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        phone: state.phone,
      },
      onSubmit: handleSubmit,
      isDisabled: !!orderingForSale.orderingId,
      customerPhone: orderingForSale.customer.phone,
      ref: formikRef,
      isVisiblePhone: props.isVisiblePhone
    };

    return (
      <>
        <Device desktop>
          <Card>
            <Card.Body>
              <CustomerForm {...commonFormProps}>
                <div className="card-footer confirm-btn-wrap" style={{ borderTopWidth: "0px", marginTop: "0px" }}>
                  <Row className="mb-3">
                    <Col md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "20px" }}>
                      Всего к оплате:
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6} lg={6} xl={6} xxl={6} className="order-total">
                      <span data-qa-locator="total-sum" className="text-span-price">
                        {props.orderingForSale.totalSum.toLocaleString("ru")}&nbsp;<i className="fa-solid fa-ruble-sign" />
                      </span>
                      <Row className="mb-3" style={{ paddingBottom: "7%" }}>
                        <Col md={12} lg={12} xl={12} xxl={12}>
                          <span className="text-span-gray">
                            оплата всей стоимости заказа
                          </span>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={6} lg={6} xl={6} xxl={6}>
                      <div className="d-grid gap-2 col-8">
                        <button className="btn btn-danger" data-qa-locator="btn-pay-total-sum" data-bs-toggle="button" style={{ fontSize: "18px" }} type="submit"
                          onClick={() => {
                            setState((prevState) => ({
                              ...prevState,
                              paymentType: PaymentType.PayByCard,
                            }));
                          }}>
                          Оплатить{" "}
                          {props.orderingForSale.totalSum.toLocaleString("ru")}
                          &nbsp;
                          <i className="fa-solid fa-ruble-sign" style={{ fontSize: "16px" }} />
                        </button>
                      </div>
                    </Col>
                  </Row>

                  {props.accountPaymentForTinkoff && (
                    <Row className="mb-3">
                      <Col md={6} className="order-total">
                        <span data-qa-locator="payment-installments-sum" className="text-span-price">
                          {props.paymentInstallments?.toLocaleString("ru")}&nbsp;
                          <i className="fa-solid fa-ruble-sign"></i>/мес.
                        </span>
                        <Row className="mb-3" style={{ paddingBottom: "7%" }}>
                          <Col md={12}>
                            <span className="text-span-gray">
                              оплата частями
                            </span>
                          </Col>
                        </Row>
                      </Col>

                      <Col md={6} lg={6} xl={6} xxl={6}>
                        <div className="d-grid gap-2 col-8">
                          <button className="btn btn-primary"
                            onClick={() => {
                              setState((prevState) => ({
                                ...prevState,
                                paymentType: PaymentType.Tinkoff,
                              }));
                            }}
                            data-qa-locator="btn-payment-installments"
                            type="submit"
                            data-bs-toggle="button"
                            style={{ fontSize: "18px" }}>
                            Оплатить{" "}
                            {props.paymentInstallments?.toLocaleString("ru")}&nbsp;
                            <i className="fa-solid fa-ruble-sign" style={{ fontSize: "16px" }} />
                          </button>
                        </div>
                      </Col>
                    </Row>
                  )}
                </div>
              </CustomerForm>
            </Card.Body>
          </Card>
        </Device>

        <Device mobile>
          <>
            <p className="bb" style={{ marginTop: '5%', marginBottom: 0 }}>
              Контактные данные:
            </p>

            <CustomerForm {...commonFormProps}>
              <Row className="mb-3">
                <Col xs={12} sm={12} md={12} className="order-total" data-qa-locator="total-sum">
                  Всего к оплате:
                </Col>
              </Row>

              <Row className="mb-3">
                <Col xs={5} sm={5} md={5} className="order-total">
                  <span className="text-span-price" data-qa-locator="total-sum">
                    {props.orderingForSale.totalSum.toLocaleString("ru")}
                    &nbsp;<i className="fa-solid fa-ruble-sign"></i>
                  </span>
                  <Row className="mb-3 lh-1">
                    <Col xs={12} sm={12} md={12}>
                      <span className="pay-span">
                        оплата всей стоимости заказа
                      </span>
                    </Col>
                  </Row>
                </Col>

                <Col xs={7} sm={7} md={7}>
                  <button className="btn btn-danger" type="submit" data-qa-locator="btn-pay-total-sum" data-bs-toggle="button"
                    onClick={() => {
                      setState((prevState) => ({
                        ...prevState,
                        paymentType: PaymentType.PayByCard,
                      }));
                    }}
                  >
                    Оплатить{" "}
                    {props.orderingForSale.totalSum.toLocaleString("ru")}
                    &nbsp;<i className="fa-solid fa-ruble-sign"></i>
                  </button>
                </Col>
              </Row>

              {props.accountPaymentForTinkoff && (
                <Row className="mb-3">
                  <Col xs={5} sm={5} md={5} className="order-total">
                    <span data-qa-locator="payment-installments-sum" className="text-span-price">
                      {props.paymentInstallments?.toLocaleString("ru")}&nbsp;
                      <i className="fa-solid fa-ruble-sign"></i>/мес.
                    </span>
                    <Row className="mb-3 lh-1">
                      <Col xs={12} sm={12} md={12}>
                        <span className="pay-span">
                          оплата частями
                        </span>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={7} sm={7} md={7}>
                    <button className="btn btn-primary" data-qa-locator="btn-payment-installments" type="submit" data-bs-toggle="button"
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          paymentType: PaymentType.Tinkoff,
                        }));
                      }}
                    >
                      Оплатить {props.paymentInstallments?.toLocaleString("ru")}
                      &nbsp;<i className="fa-solid fa-ruble-sign"></i>
                    </button>
                  </Col>
                </Row>
              )}
            </CustomerForm>
          </>
        </Device>
      </>

    );
  };

  return (
    <>
      <Spinners isActive={isLoading} />
      {props.orderingForSale && (
        <>
          {renderOrderInfo()}
          {renderCustomerForm()}
        </>
      )}
    </>
  );
};